import { callUpdateRobotConsumablePart } from "api/worker/robot";
import { useModal } from "hooks/useModal";
import { robotKey } from "hooks/worker/keys";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { CleaningRobotItem } from "types/response/robot";
import { handleError } from "utils/error/handleError";
import { ConsumablePartType } from "utils/robot/consumablePart";

type ResetModalProps = {
  robotId: string;
  afterCallback?: () => void;
};

export const useResetModal = ({ robotId, afterCallback }: ResetModalProps) => {
  const modal = useModal();
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const onReset = async (
    input: {
      type: ConsumablePartType;
      usage: number;
    }[]
  ) => {
    setIsLoading(true);
    try {
      await callUpdateRobotConsumablePart({ robotId, parts: input });

      queryClient.setQueryData<CleaningRobotItem[] | undefined>(
        robotKey.list(),
        (prev) => {
          if (!prev) return prev;
          return prev.map((robot) => {
            if (robot.robotId !== robotId) return robot;
            robot.consumableParts = robot.consumableParts.map((part) => {
              const updated = input.find((i) => i.type === part.type);
              return {
                ...part,
                usage: updated?.usage ?? 0,
              };
            });
            return robot;
          });
        }
      );

      modal.onClose();

      if (afterCallback) afterCallback();
    } catch (err) {
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    ...modal,
    onReset,
    isLoading,
  };
};
